import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import LoanPrograms from "./pages/LoanPrograms";
import TeamPage from "./pages/TeamPage";
import Calculators from "./pages/Calculators";
import EventsPage from "./pages/EventsPage";
import EducationPage from "./pages/EducationPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";

// Admin components
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import TeamAdmin from "./components/admin/TeamAdmin";
import EventsAdmin from "./components/admin/EventsAdmin";
import BlogAdmin from "./components/admin/BlogAdmin";
import AdminSettings from "./components/admin/AdminSettings";
import ProtectedRoute from "./components/admin/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-white">
        <BrowserRouter>
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/team" 
              element={
                <ProtectedRoute>
                  <TeamAdmin />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/events" 
              element={
                <ProtectedRoute>
                  <EventsAdmin />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/blog" 
              element={
                <ProtectedRoute>
                  <BlogAdmin />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/settings" 
              element={
                <ProtectedRoute>
                  <AdminSettings />
                </ProtectedRoute>
              } 
            />
            
            {/* Public Routes */}
            <Route 
              path="/*" 
              element={
                <>
                  <Header />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/loan-programs" element={<LoanPrograms />} />
                      <Route path="/team" element={<TeamPage />} />
                      <Route path="/calculators" element={<Calculators />} />
                      <Route path="/events" element={<EventsPage />} />
                      <Route path="/education" element={<EducationPage />} />
                      <Route path="/privacy" element={<PrivacyPolicy />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } 
            />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;